<h1 transloco="{{errorTitle}}"></h1>
<div transloco="{{errorDescription}}"></div>
<div *ngIf="errorCode === '404'">
  <a href="/" transloco="error.notFoundLink"></a>
</div>
<div *ngIf="errorCode === '403' && !isAuthenticated">
  <a href="/b/sign-in" transloco="error.accessDenied"></a>
</div>
